import './social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.ImageContentView extends Monitoring.Views.SocialContents.SocialContentView
  tagName: "section"
  className: "content image"

  initialize: (@options = {}) ->
    super
    @status = ''

  getActiveTags: ->
    #Override necesary since the tags are not in the same format than other social contents.
    #Applied Tag Objects
    tag_codes  = _.map(@$el.find('.tagging-button.active'), (tag) => $(tag).data('code'))
    _.filter(@model.possibleTags(), (tag) => tag_codes.indexOf(tag.code) != -1)

  _rejectImage: =>
    unless @$el.find('.reivew-image img').hasClass('rejected')
      @$el.find('.reivew-image img').addClass('rejected')
      @$el.find('.fa-times').css('display', 'initial')

  _onClearRejection: =>
    if @$el.find('.reivew-image img').hasClass('rejected')
      @$el.find('.reivew-image img').removeClass('rejected')
      @$el.find('.fa-times').css('display', 'none')

  _renderTags: ->
    @socialContentTagsView = new Monitoring.Dashboard.SocialContentImageTagsView(model: @model)
    @socialContentTagsView.bind('moderate', @moderate)
    @socialContentTagsView.bind('imageRejected', @_rejectImage)
    @socialContentTagsView.bind('clearRejection', @_onClearRejection)
    @$el.find(".reivew-tags-section").append(@socialContentTagsView.render())
